const buildDefaultOptions = () => {
    const internalHosts = [window.location.host];
    if (window.parent != null && window !== window.parent) {
        if (document.referrer) {
            internalHosts.push(new URL(document.referrer).host);
        }
    }
    return {
        internalHosts,
        internalLinkTitle: '',
        externalLinkTitle: 'Opens in new window',
        internalLinkClass: 'bff-anchor-int',
        externalLinkClass: 'bff-anchor-ext',
        internalLinkTarget: '_parent',
        externalLinkTarget: '_blank',
        externalLinkIcon: true,
        externalLinkIconClass: 'bff__webchat__markdown__external-link-icon'
    };
};
export const defaultedMarkdownLinkTargetOptions = (options) => (Object.assign(Object.assign({}, buildDefaultOptions()), options));
//# sourceMappingURL=markdownLinkTargetOptions.js.map